import { createContext, useContext } from 'react';

export const SlackAgentContext = createContext(null);

// Null outside a provider, so shared chat components stay inert on pages that do not offer Slack.
export const useSlackAgent = () => useContext(SlackAgentContext);
